import { type FC } from 'react';
import styled from 'styled-components';

import { useCurrentUserInfo } from '@/auth/hooks';
import { Column, Row } from '@/components/Grid';
import { OrganizationSelector } from '@/components/OrganizationSelector';
import { useTexts } from '@/hooks/useTexts';

export const HeaderSection: FC = () => {
  const texts = useTexts();

  const { name } = useCurrentUserInfo();

  const title = name ? `${texts.home.title} ${name}!` : `${texts.home.title}!`;

  return (
    <>
      <h1>{title}</h1>
      <StyledRow>
        <Column $span={7}>
          <OrganizationSelector initialCollapseSize={5} />
        </Column>
        <StyledColumn $span={5}>
          <ImgWrapper>
            <img
              alt="Profitable sustainability illustration"
              src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/profitable-sustainability.svg`}
            />
          </ImgWrapper>
        </StyledColumn>
      </StyledRow>
    </>
  );
};

const StyledRow = styled(Row)`
  padding: 0 24px;
`;

const StyledColumn = styled(Column)`
  display: flex;
`;

const ImgWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-height: 500px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
